.options {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 20px;
}

.options button {
  padding: 8px 16px;
  border: none;
  border-radius: 5px;
  background-color: #4a90e2;
  color: white;
  cursor: pointer;
}

.options button:hover {
  background-color: #357abd;
}

.reset {
  background-color: #e94e4e;
}

.reset:hover {
  background-color: #c73c3c;
}